import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconoirSortUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 43,
	viewBox: "0 0 43 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_492_356)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 43,
			height: 43,
			fill: "#B9F833"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M25.8 25H9M20.2 19.4H9M14.6 13.8H9M31.4 30.6H9M32.8 25V11M32.8 11L37 15.2M32.8 11L28.6 15.2",
			stroke: "white",
			strokeWidth: 1.5625,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_492_356",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 43,
			height: 43,
			fill: "white"
		})
	}) })]
});
export default SvgIconoirSortUp;
